import React from 'react';
import { BrowserRouter as MainRouter, Route, Switch } from 'react-router-dom';
import Cookies from 'universal-cookie';
// import './styles/main.css';
import './tailwind.css'
import './App.css';
import FooterSite from './Components/FooterSite';
import NavBarSite from './Components/NavBarSite';
import NavSection from './Components/NavSection';
import TopBarSite from './Components/TopBarSite';
import methodsTwoContext from './Contexts/MethodsTwo';
import './fontawesome.min.css';
import About from './Routes/About';
import Ads from './Routes/Ads';
import Article from './Routes/Article';
import Projects from './Routes/Projects';
import ContactUs from './Routes/ContactUs';
import Contribution from './Routes/Contribution';
import Discuss from './Routes/Discuss';
import FAQs from './Routes/FAQs';
import Login from './Routes/Login';
import LoginSample from './Routes/LoginSample';
import Main from './Routes/Main';     
import NotFound from './Routes/NotFound';
import PodCast from './Routes/PodCast';
import Register from './Routes/Register';
import RegisterSample from './Routes/RegisterSample';
import RegisterSample3 from './Routes/RegisterSample3';
import WebApp from './Routes/WebApp';
import WebDesign from './Routes/WebDesign';
import MobileApp from './Routes/MobileApp';
import ManageProfile from './Routes/Text_Rich_Editor_Tiny';
import Remember from './Routes/Remember';
import PageContent from './Routes/PageContent';
import logger from './Tools/Log';
import ScrollAnimation from 'react-animate-on-scroll';





export default class App extends React.Component {


  // constructor(props) {
  //   super(props);

  // }



  state = {
    name: '',
    accessToken: '',
    username: ''
  }


  // componentDidMount() {

  // }

  componentDidUpdate() {
    this.setCookies();
  }

  setCookies(remove) {
    const cookies = new Cookies();

  
    if(remove){
      cookies.remove('bitkalaAuth', { path: '/' });
      cookies.remove('bitkalaUsername', { path: '/' });
    }
    else if (this.state.accessToken !== cookies.get('bitkalaAuth') && this.state.accessToken !== '') {

      logger('MainPage>>App.js>>setCookies>>name: ' + this.state.name
        + ' token: ' + (this.state.accessToken ? 'yes' : 'no'),
        ' username: ' + this.state.username)
     const expires = new Date()
      expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 9)

      cookies.set(
        'bitkalaAuth',
        this.state.accessToken,
        {
          path: '/',
          // expires: expires,
           maxAge: 10000000
          // domain: 'http://localhost:3000/',
          // secure: false,
          //  httpOnly: true
        }
      )

      cookies.set(
        'bitkalaUsername',
        this.state.username,
        {
          path: '/',
          // expires: expires,
          maxAge: 10000000
          // domain: 'http://localhost:3000/',
          // secure: false,
          //  httpOnly: true
        }
      )

    }
  }



  getCookies() {

    const cookies = new Cookies();
    if (this.state.accessToken === '' && cookies.get('bitkalaAuth') !== undefined && cookies.get('bitkalaAuth') !== '') {


      logger('MainPage>>App.js>>getCookies>>name: ' + this.state.name
        + ' token: ' + (this.state.accessToken ? 'yes' : 'no'),
        ' username: ' + this.state.username)

      this.state.accessToken = cookies.get('bitkalaAuth');
      this.state.username = cookies.get('bitkalaUsername');

      logger('MainPage>>App.js>>getCookies>>next>>name: ' + this.state.name
        + ' token: ' + (this.state.accessToken ? 'yes' : 'no'),
        ' username: ' + this.state.username)

    }
  }

  render() {
    logger('MainPage>>App.js>>render');
    this.getCookies();
    return (
      <methodsTwoContext.Provider value={{
        authorizationInfo: this
      }}>
        <MainRouter>
          <div className="App">
            <div id="app" class="wrapper" >
              <header class="header_section">
                <div class="nav">
                  <TopBarSite />
                  <NavSection />
                </div>
                <NavBarSite />
              </header>
              {/* <ScrollAnimation animateIn="fadeIn">
              <img src='https://unsplash.it/900/900/?random' />
              </ScrollAnimation> */}

              <main style={{minHeight:'400px'}}>
                <Switch>
                  <Route path="/" exact component={Main} />
                  <Route path='/events/edit/:id' component={Remember} />
                  <Route path='/events' component={Remember} />
                  <Route path='/about-us' component={About} />
                  <Route path='/Articles/:id' component={PageContent} />
                  <Route path='/Articles' component={Article} />  
                  <Route path='/Projects' component={Projects} /> 
                  <Route path='/PodCast' component={PodCast} />
                  <Route path='/contact-us' component={ContactUs} />
                  <Route path='/Contribution' component={Contribution} />
                  <Route path='/Discuss' component={Discuss} />
                  <Route path='/Login' component={Login} />
                  <Route path='/WebApp' component={WebApp} />
                  <Route path='/WebDesign' component={WebDesign} />
                  <Route path='/MobileApp' component={MobileApp} />
                  <Route path='/ManageProfile' component={ManageProfile} />
                  <Route path='/RegisterSample' component={RegisterSample} />
                  <Route path='/RegisterSample3' component={RegisterSample3} />
                  <Route path='/Register' component={Register} />
                  <Route path='/LoginSample' component={LoginSample} />
                  <Route path='/FAQs' component={FAQs} />
                  <Route path='/404' component={Main} />
                  <Route path='' component={Main} />
                  {/* <Route path='/404' component={NotFound} />
                  <Route path='' component={NotFound} /> */}
                </Switch>
              </main>


            </div>
         
            <FooterSite />
   
           
          </div>
        </MainRouter>
      </methodsTwoContext.Provider>
    )
  }
}


// return (
//   <div className="">
//   <div className="p-4 m-4 bg-green-700">
//     <h1 className="text-2xl font-bold text-white">Tailwind CSS Demo</h1>
//   </div>
//   <div className="p-4 m-4 bg-green-100 h-full">
//     <h2 className="text-green-900">Have much fun using Tailwind CSS</h2>
//     <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">My Tailwind Button</button>
//   </div>
// </div>
// )